import React, { useEffect, useRef, useState } from "react";
import "./Proposal.css";
import DOMPurify from 'dompurify';
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import TranslateWidget from "../Shared/TranslateWidget/TranslateWidget";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import TextEditorToSection from "../Customer-View/TextEditorToSection";
import CreatePayContent from "./CreatePayContent";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import CommonDropdownMenuThree from "../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../Shared/CommonDropdownMenufour";
import "../CreateInvoice/CreateInvoice.css";
import UnitOption from "./UnitOption";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
import "./TextEditor.css";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';

export default React.memo(function ViewProposal() {

  const [formData, setFormData] = useState({
    mainLogo: "",
    secondaryLogo: "",
    defaultHeaderImage: "",
  });

  const [companylogo, setCompanylogo] = useState();

  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();

  const [invoicepayments, setinvoicepayments] = useState([]);



  const { proposalid, code } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const title = useSelector((state) => state.title.title);

  const options = ["Custom Date", 'Smart date'];
  const options_sub = ["Payment is due on a fixed calendar date", 'Payment due date is based on event or invoice date'];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

  const editorRef = useRef(null);
  const childStateRef = useRef();
  const [showDueDateBox, setShowDueDateBox] = useState(null);
  const [showTaxBox, setShowTaxBox] = useState(false);
  const [showDiscountBox, setShowDiscountBox] = useState(false);

  const [contractpresent, setcontractpresent] = useState(false);
  const [sharedproposalinvoice, setsharedproposalinvoice] = useState(null);

  const [subtotalprice, setsubtotalprice] = useState(0);
  const [totalprice, settotalprice] = useState(0);
  const [tax, settax] = useState(0);
  const [taxval, settaxval] = useState(0);
  const [taxper, settaxper] = useState(false);
  const [discount, setdiscount] = useState(0);
  const [discountval, setdiscountval] = useState(0);
  const [discountper, setdiscountper] = useState(false);

  const [invoicecode, setinvoicecode] = useState(0);


  const [smartdate, setsmartdate] = useState(false);
  const [smartday, setsmartday] = useState("");
  const [smartmonth, setsmartmonth] = useState(false);
  const [smartyear, setsmartyear] = useState(false);

  const [contractadded, setcontractadded] = useState(false);
  const [invoiceadded, setinvoiceadded] = useState(false);
  const [pagescontent, setPagescontent] = useState([]);




  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [length, setlength] = useState(0);

  const [username, setusername] = useState('');
  const [useremail, setuseremail] = useState('');
  const [customername, setcustomername] = useState('');
  const [customeremail, setcustomeremail] = useState('');

  const [customersignature, setcustomersignature] = useState('');
  const [signaturebox, setsignaturebox] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [showsign, setshowsign] = useState(false);


  const [alreadysigned, setalreadysigned] = useState(false);

  const [loading, setloading] = useState(false);

  const [purchageorder, setpurchageorder] = useState('');

  const [showpaging, setshowpaging] = useState(false);

  const [shareduserdetail, setshareduserdetail] = useState([]);
  const [usersignature, setUsersignature] = useState('');

  const [showTooltip, setShowTooltip] = useState(false);


  const handleChange = (event) => {
    setsignaturebox(event.target.value);
  };
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  const addsignature = async () => {

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/setcustomersignproposal`,
        {
          sharedid: proposalid,
          signature: signaturebox,
        });

      if (response.data.success) {
        // alert('Email send Sucessfully');
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Action complete Sucessfully!",
        });


        // navigate("/events");
      }

      setcustomersignature(signaturebox);
      // setshowsign(false);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    }



  };


  const handleMouseOver = () => setShowTooltip(true);
  const handleMouseOut = () => setShowTooltip(false);






  const handleNextPage = () => {
    
    if (currentPage < length + 1) {
      setCurrentPage(currentPage + 1);

    } else {

      if(currentPage==0){
      //handleSubmit();

      alert('page submit');

    }

    }


    if (pagescontent[0].type == 'contract') {
      if (currentPage == pagescontent.filter(page => page.type === 'contract').length - 2) {
        setshowsign(true);
      } else {
        setshowsign(false);
      }


    } else {

      if (currentPage == pagescontent.filter(page => page.type === 'contract').length) {
        setshowsign(true);
      } else {
        setshowsign(false);
      }
    }

    expandtextbox();


    if (usersignature != '' && currentPage == length) {


      const styleTag = document.createElement("style");
     // styleTag.innerHTML = "body { background-color: #f1f4f9 !important; }";

      // Append the <style> tag to the head
      document.head.appendChild(styleTag);

    }
    


    if (pagescontent[currentPage].type == 'questionnaires') {
      handleSubmit(); 
    }

    


  };

  // Handler for the previous button
  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }

    if (currentPage - 2 == pagescontent.filter(page => page.type === 'contract').length) {
      setshowsign(true);
    } else {
      setshowsign(false);
    }

  };



    const handleSubmit = async () => {



     
    try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/sendproposalupdate/${proposalid}`, 
                    {
                     proposal:JSON.stringify(proposalstabs),
                     code: code,
                    });

                    if(response.data.success){

                      



                       
                     }
                      

    } catch (error) {
      console.error("Error fetching contracts:", error);
    }

  }





  const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const formattedDate = `${months[currentDate.getMonth()]
    } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  const [showSideCanvas, setShowSideCanvas] = useState(true);
  const [contractCount, setContractCount] = useState(1);

  const [openlist, setOpenlist] = useState("");

  const [questionnaires, setQuestionnaires] = useState("");

  const [contracts, setContracts] = useState([]);

  const [invoices, setInvoices] = useState([]);

  const [proposalpages, setProposalpages] = useState([]);




  const [proposalstabs, setProposalstabs] = useState([]);

  const [pageaddstatus, setPageaddstatus] = useState(true);


  const ref2 = useRef([]);
  const handleInput = (e, index) => {
    if (ref2.current[index]) {
      ref2.current[index].style.height = "auto";
      ref2.current[index].style.height = `${ref2.current[index].scrollHeight + 16}px`;
    }
  };


  const textareaRef = useRef(null);

  // Function to adjust the height of the textarea
  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height to auto to calculate the new height
      textarea.style.height = `${textarea.scrollHeight + 16}px`; // Set the height based on scrollHeight
    }
  };

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [pagescontent, currentPage]);




  const addtoproposal = () => {
    setProposalstabs([...proposalstabs, {
      type: 'contract',
      id: "v-pills-home",
      title: "Contract",
      content: `<div>
        <h1>Contract</h1>
        <p className="mt-5">Please type or copy and paste the content of your contract here. Alternatively, you can import one of your contract templates using the right panel. </p> 
        <p className="mt-5">If you don’t have a contract, you can browse our template gallery for lawyer-approved free contracts.</p> 
        <p className="mt-5">And remember to delete this text before sending.</p>
        <p className="smart_text">smart_text</p>
      </div>`,
    }]);



  };


  const addpage = () => {
    const pagel = proposalpages.length + 1;
    setProposalpages([...proposalpages, {
      name: "Page" + pagel,
      content: `<div>
        <h1>Page ${pagel}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
    }]);
  }




  const addcontracttoproposal = (index) => {
    const newcontract = { type: "contract", title: contracts[index].title, pages: contracts[index].pages };
    setProposalstabs([...proposalstabs, newcontract]);
    setOpenlist("");
    setShowSideCanvas(false);
    setPageaddstatus(false);



  }

  const addinvoicetoproposal = (index) => {
    const newinvoice = {
      type: 'invoice', title: invoices[index].title, pages: invoices[index].invoice_page, invoice_item: invoices[index].invoice_item,
      invoice_payment: invoices[index].invoice_payment,
      taxper: invoices[index].taxper,
      tax: invoices[index].tax,
      discountper: invoices[index].discountper,
      discount: invoices[index].discount,
    };
    setProposalstabs([...proposalstabs, newinvoice]);
    setOpenlist("");
    setShowSideCanvas(false);
    setPageaddstatus(false);

  }

  const addquestionnairestoproposal = (index) => {
    const newquestionnaires = { type: 'questionnaires', title: questionnaires[index].title, questionss: questionnaires[index].questionss };
    setProposalstabs([...proposalstabs, newquestionnaires]);
    setOpenlist("");
    setShowSideCanvas(false);
    setPageaddstatus(false);



  }


  useEffect(() => {
    dispatch(setTitle('Untitled Proposals'));
  }, []);


  const [tabs, setTabs] = useState([
    {
      id: "v-pills-home",
      title: "Contract",
      content: `<div>
        <h1>Contract</h1>
        <p className="mt-5">Please type or copy and paste the content of your contract here. Alternatively, you can import one of your contract templates using the right panel. </p> 
        <p className="mt-5">If you don’t have a contract, you can browse our template gallery for lawyer-approved free contracts.</p> 
        <p className="mt-5">And remember to delete this text before sending.</p>
        <p className="smart_text">smart_text</p>
      </div>`,
    },
  ]);

  const handleClose = () => {
    setShowSideCanvas(false);
  };

  const handleAddPage = () => {
    setShowSideCanvas(true);
  };

  const handleEditorChange = (content, tabId) => {
    setProposalpages((prevTabs) =>
      prevTabs.map((tab, index3) =>
        index3 === tabId ? { ...tab, content: content } : tab
      )
    );
  };

  const renamepage = (tabId) => {

    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      // const tabTitle = document.querySelector(`#${newTabId}-tab .box-title`);
      // tabTitle.textContent = newTitle;
      // alert("dhirendra");
      setProposalpages((prevTabs) =>
        prevTabs.map((tab, index3) =>
          index3 === tabId ? { ...tab, name: newTitle } : tab
        )
      );
    }


  }


  const handleClick2 = (id) => {

    setTimeout(() => {


      setProposalstabs(prevTabs => prevTabs.filter((item, index3) => index3 !== id));

    }, 1000);

    if (proposalstabs[id].type == 'invoice') {

      setinvoiceadded(false);

    }

    if (proposalstabs[id].type == 'contract') {

      setcontractadded(false);

    }



  };

  const handleClick = (id) => {
    setProposalpages(prevTabs => prevTabs.filter((item, index3) => index3 !== id));
  };

  const handleclone = (cloneid) => {

    const clonetab = proposalpages.filter((item, index3) => index3 === cloneid);

    const pagel = proposalpages.length + 1;

    const newTabTitle = `Page ${pagel}`;

    const newTab = {
      name: newTabTitle,
      content: clonetab[0].content,
    };

    setProposalpages([...proposalpages, newTab]);

  }

  useEffect(() => {


    const fetchproposal = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sharedproposal/${proposalid}/${code}`);


        setsharedproposalinvoice(response.data.sharedproposal);

        if (response.data.sharedproposal.signed != 'yes') {



          setUsersignature(response.data.sharedproposal.usersignature);

          setpurchageorder(response.data.sharedproposal.purchageorder);


          setshareduserdetail(response.data.user);


          setCompanylogo(response.data.user.Main_Logo ? process.env.REACT_APP_BACKEND_URL + response.data.user.Main_Logo : null);

          setPhone(response.data.user.Phone_Number);
          setCompanyemail(response.data.user.Company_Email);
          setFname(response.data.user.first_name);
          setLname(response.data.user.last_name);

          //var totalprice=0;
          dispatch(setTitle(response.data.sharedproposal.title));
          setProposalstabs(JSON.parse(response.data.sharedproposal.content));
          setProposalpages(JSON.parse(response.data.sharedproposal.pages));

          setinvoicecode(response.data.sharedproposal.invoicecode);

          const pages = JSON.parse(response.data.sharedproposal.content);

          JSON.parse(response.data.sharedproposal.pages).forEach(element => {
            let contentnew = { type: 'contract', content: element.content };
            setPagescontent(prevContent => [...prevContent, contentnew]);

          });

          pages.forEach(element => {

            if (element.type == 'contract') {

              setcontractpresent(true);

            element.pages.forEach(contractelement => {
                let contentnew = { type: 'contract', content: contractelement.content };
                setPagescontent(prevContent => [...prevContent, contentnew]);

              });
            } else if (element.type == 'invoice') {
              let contentnew = { type: 'invoice', content: element };
              setPagescontent(prevContent => [...prevContent, contentnew]);
              let paymenttab = { type: 'payment', content: 0 };
              setPagescontent(prevContent => [...prevContent, paymenttab]);
            } else if (element.type == 'questionnaires') {
              let contentnew = { type: 'questionnaires', content: element.questionss };
              setPagescontent(prevContent => [...prevContent, contentnew]);
            }



          });




          setusername(response.data.sharedproposal.username);
          setuseremail(response.data.sharedproposal.user_email);
          setcustomername(response.data.sharedproposal.customer_name);
          setcustomeremail(response.data.sharedproposal.customer_email);

          setloading(true);








        } else {
          setalreadysigned(true);
        }

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchproposal();







  }, []); // This runs once when the component mounts




  useEffect(() => {
    // what should happen after the initial render
    const indexval = proposalstabs.length;
    const buttonid = `${indexval - 1}-tab`;
    const activebutton = document.getElementById(buttonid);
    if (activebutton) {
      activebutton.click();
    }
    //active.setAttribute("data-scroll", <your_value>)
  }, [proposalstabs.length]);





  useEffect(() => {



    var totalprice = 0;
    proposalstabs.map((ptab) => {

      if (ptab.type == 'contract' && contractadded == false) {
        setcontractadded(true);
      } else if (ptab.type == 'invoice' && invoiceadded == false) {
        setinvoiceadded(true);

      }






      if (ptab.type == 'invoice') {

        setinvoicepayments(ptab.invoice_payment);
        ptab.invoice_item.map((tab1) => {
          totalprice = parseFloat(totalprice) + parseFloat(tab1.price);
        });

        setsubtotalprice(totalprice);
        if (parseInt(ptab.taxper) > 0) {
          totalprice = parseFloat(totalprice) + parseFloat(ptab.taxper * totalprice / 100);
          settaxval(parseFloat(ptab.taxper) * totalprice / 100);
        } else {
          totalprice = parseFloat(totalprice) + parseFloat(ptab.tax);
          settaxval(ptab.tax);
        }
        if (parseInt(ptab.discountper)) {
          totalprice = totalprice - parseInt(ptab.discountper * totalprice / 100);
          setdiscountval(ptab.discountper * totalprice / 100);
        } else {
          totalprice = totalprice - parseInt(ptab.discount);
          setdiscountval(ptab.discount);
        }
        settotalprice(totalprice);

      }
    });



    if (proposalstabs.length > 0) {

      const proposaltablenght = proposalstabs.length - 1;

      var buttonid = '';

      if (proposalstabs[proposaltablenght].type == 'contract') {
        buttonid = `ctab0${proposaltablenght}`;
      } else if (proposalstabs[proposaltablenght].type == 'invoice') {
        buttonid = `invoicetab${proposaltablenght}${proposaltablenght}`;
      } else if (proposalstabs[proposaltablenght].type == 'questionnaires') {
        buttonid = `qutab${proposaltablenght}`;
      }



      const activebutton = document.getElementById(buttonid);
      if (activebutton) {
        activebutton.click();
      }

    }



    //active.setAttribute("data-scroll", <your_value>)
  }, [proposalstabs]);


  useEffect(() => {


    setTimeout(function () {
      ref2.current.map((tab, index) => {
        if (ref2.current[index]) {
          ref2.current[index].style.height = "auto";
          ref2.current[index].style.height = `${ref2.current[index].scrollHeight + 16}px`;
        }
      });



    }, 2000);

    if (contractpresent == true && pagescontent.filter(page => page.type === 'contract').length == 1) {
      setshowsign(true);
      // setshowpaging(true);

    }
  }, [proposalstabs]);

  const expandtextbox = () => {
    setTimeout(function () {
      ref2.current.map((tab, index) => {
        if (ref2.current[index]) {
          ref2.current[index].style.height = "auto";
          ref2.current[index].style.height = `${ref2.current[index].scrollHeight + 16}px`;
        }
      });


    }, 1000);

  }


  useEffect(() => {

    setlength(pagescontent.length - 1);





  }, [proposalstabs]);


  const handlePlaceholderChange = (e, currentPage, ind) => {
  const { value } = e.target;


  const questionnairesIndex = proposalstabs.findIndex(
  (tab) => tab.type === "questionnaires"
);

  setProposalstabs((prevTabs) => {
    return prevTabs.map((tab, tabIndex) => {
      // Only update the questionnaires tab at the given index
      if (tabIndex === questionnairesIndex && tab.type === "questionnaires") {
        return {
          ...tab,
          questionss: tab.questionss.map((q, qIndex) => {
            if (qIndex === ind) {
              return {
                ...q,
                placeholder: value, // immutably update placeholder
              };
            }
            return q;
          }),
        };
      }
      return tab;
    });
  });
};


/*
  const handlePlaceholderChange = (e, pageIndex, contentIndex) => {
    // Create a copy of pagescontent
    const updatedPagesContent = [...pagescontent];
    // Update the specific content's placeholder
    updatedPagesContent[pageIndex].content[contentIndex].placeholder = e.target.value;

    // Set the updated state
    setPagescontent(updatedPagesContent);


 


  }; */

   const handlePlaceholderChange2 = (e, currentPage, ind) => {
  const { value } = e.target;


  const questionnairesIndex = proposalstabs.findIndex(
  (tab) => tab.type === "questionnaires"
);

  setProposalstabs((prevTabs) => {
    return prevTabs.map((tab, tabIndex) => {
      // Only update the questionnaires tab at the given index
      if (tabIndex === questionnairesIndex && tab.type === "questionnaires") {
        return {
          ...tab,
          questionss: tab.questionss.map((q, qIndex) => {
            if (qIndex === ind) {
              return {
                ...q,
                placeholder2: value, // immutably update placeholder
              };
            }
            return q;
          }),
        };
      }
      return tab;
    });
  });
};

/*  const handlePlaceholderChange2 = (e, pageIndex, contentIndex) => {
    // Create a copy of pagescontent
    const updatedPagesContent = [...pagescontent];
    // Update the specific content's placeholder
    updatedPagesContent[pageIndex].content[contentIndex].placeholder2 = e.target.value;

    // Set the updated state
    setPagescontent(updatedPagesContent);
  };
  */


  const handlePlaceholderChange3 = (e, quesIndex) => {
  const { value, checked } = e.target;

  const questionnairesIndex = proposalstabs.findIndex(
  (tab) => tab.type === "questionnaires"
);

  setProposalstabs((prevTabs) => {
    return prevTabs.map((tab) => {
      if (tab.type === "questionnaires") {
        return {
          ...tab,
          questionss: tab.questionss.map((q, qIndex) => {
            if (qIndex === quesIndex) {
              let placeholder2 = Array.isArray(q.placeholder2)
                ? [...q.placeholder2]
                : [];

              if (checked) {
                // add value
                if (!placeholder2.includes(value)) {
                  placeholder2.push(value);
                }
              } else {
                // remove value
                placeholder2 = placeholder2.filter((item) => item !== value);
              }

              return { ...q, placeholder2 };
            }
            return q;
          }),
        };
      }
      return tab;
    });
  });
};

/*

   const handlePlaceholderChange3 = (e, currentPage, ind) => {
  const { value } = e.target;


  const questionnairesIndex = proposalstabs.findIndex(
  (tab) => tab.type === "questionnaires"
);

  setProposalstabs((prevTabs) => {
    return prevTabs.map((tab, tabIndex) => {
      // Only update the questionnaires tab at the given index
      if (tabIndex === questionnairesIndex && tab.type === "questionnaires") {
        return {
          ...tab,
          questionss: tab.questionss.map((q, qIndex) => {
            if (qIndex === ind) {
              return {
                ...q,
                placeholder2: value, // immutably update placeholder
              };
            }
            return q;
          }),
        };
      }
      return tab;
    });
  });
};
*/
/*
  const handlePlaceholderChange3 = (e, pageIndex, contentIndex) => {
    const value = e.target.value;
    const isChecked = e.target.checked;

    setPagescontent(prevPagesContent => {
      const newPagesContent = [...prevPagesContent];

      // Ensure placeholder2 is initialized as an array if it's undefined or not an array
      if (!Array.isArray(newPagesContent[pageIndex].content[contentIndex].placeholder2)) {
        newPagesContent[pageIndex].content[contentIndex].placeholder2 = [];
      }

      if (isChecked) {
        // Add the value if it's checked and not already present
        if (!newPagesContent[pageIndex].content[contentIndex].placeholder2.includes(value)) {
          newPagesContent[pageIndex].content[contentIndex].placeholder2.push(value);
        }
      } else {
        // Remove the value if it's unchecked
        newPagesContent[pageIndex].content[contentIndex].placeholder2 = newPagesContent[pageIndex].content[contentIndex].placeholder2.filter(
          v => v !== value
        );
      }

      return newPagesContent;
    });
  };

  */

  const generatepdf2 = async () => {
    const options = {
      margin: 1,
      filename: 'Proposal.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    };

    const styles = `
<style>
  .signaturemain {
    /* Add your CSS styles here */
    font-family: "Allura", cursive;
font-weight: 400;
font-style: normal; width: 250px; height: 70px; outline: none;  border: none; font-size: 40px;
  }
  /* Add other styles as needed */
</style>
`;
    const pdfContent = document.createElement('div');

    pdfContent.innerHTML = styles;

    // Iterate over each tab and create a section for the PDF
    pagescontent.forEach((tab, index) => {
      const tabContent = document.createElement('div');

      if (pagescontent[index].type == 'contract') {

        tabContent.innerHTML = `<p>${tab.content}</p>`;

      }

      if (pagescontent[index].type == 'invoice') {



        tabContent.innerHTML = `
    <section class="section_container">
      <div class="customer_details" style="text-align: left;">
        ${companylogo ? `
          <div class="logo">
            <h4>
              <img src="${companylogo}?t=${Date.now()}" alt="Main Logo Preview" class="mainimgpath img-fluid" />
            </h4>
          </div>` : ''}
        <div class="title">
          <h4>${companyname ? `${companyname}` : ''}</h4>
        </div>
        <div class="item">
          <div style="text-transform: capitalize;">${fname} ${lname ? `${lname}` : ''}</div>
          <div>${phone ? `${phone}` : ''}</div>
          <div>${companyemail}</div>
        </div>
        <div class="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
          <div class="table_item invoice_td position-relative" style="text-align: left; padding-left: 50px;">
            <span class="hover_effect">Bill to</span><br />
            <span>${customername}</span>
          </div>
          <div class="table_item invoice_td position-relative" style="margin-right: 6%; text-align: left;">
            <span class="hover_effect">Invoice #</span><br />
            <span>${invoicecode}</span>
          </div>
          <div class="table_item purchase_td position-relative" style="margin-right: 1%; text-align: left;">
            <span class="hover_effect">Purchase order #</span><br />
            <span>${purchageorder}</span>
          </div>
        </div>
        <div class="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
          <div></div>
          <div class="table_item table_item_date_issued position-relative" style="margin-left:50px; ">
            <span>Date Issued</span><br />
            <div class="date position-absolute" style="font-size: 14px;">${formattedDate}</div>
          </div>
          <div class="table_item position-relative">
            <span>Next Payment Due</span><br />
            <div class="date position-absolute" style="font-size: 14px;">${pagescontent[index].content.invoice_payment[0].dueDate}</div>
          </div>
        </div>
      </div>
  
      <div class="service_area d-flex align-items-center justify-content-between py-3">
        <div class="service_item">
          <div class="service_info_top">
            <span>SERVICE INFO</span>
          </div>
        </div>
        <div class="service_item d-flex align-items-center">
          <span class="me-5">QTY</span>
          <span>UNIT</span>
        </div>
        <div class="service_item">
          <span class="me-3">PRICE</span>
        </div>
      </div>
  
      ${pagescontent[index].content.invoice_item.map((service, index2) => `
        <div class="create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative">
          <div class="service_item position-relative">
            <div class="service_info_box" >
              <div class="service_info">
                <input type="text" id="name-${index2}" placeholder="Type or Select a Service" value="${service.type}" disabled style="background:none;" />
              </div>
            </div>
          </div>
          <div class="service_item d-flex align-items-center">
            <span class="me-2 qyt">${service.qty}</span>
            <span class="position-relative">&nbsp;&nbsp;&nbsp;${service.unit_option}</span>
          </div>
          <div class="service_item d-flex align-items-center">
            <div class="form-check">${service.tax ? '✓' : ''}</div>
            <div class="form-check qyt">${service.price}</div>
          </div>
          <div class="textare2 left">
            <textarea rows="1" placeholder="Enter a description" class="textare" disabled>${service.descp}</textarea>
          </div>
        </div>
      `).join('')}
  
      <div class="card-body">
        <div class="row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0">
          <div class="col-md-5 d-flex align-items-end"></div>
          <div class="col-md-7 ml-auto">
            <table class="table create_invoice_table table-clear">
              <tbody>
                <tr>
                  <td class="left"><span>Subtotal</span></td>
                  <td class="right">${subtotalprice}</td>
                </tr>
                <tr>
                  <td class="left position-relative">
                    <span class="pointer">Tax</span>
                  </td>
                  <td class="right">${taxval}</td>
                </tr>
                <tr>
                  <td class="left position-relative">
                    <span class="pointer">+ Add Discount</span>
                  </td>
                  <td class="right"><strong>${discountval}</strong></td>
                </tr>
                <tr>
                  <td class="left"><span>Total USD</span></td>
                  <td class="right"><strong>${totalprice}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <section class="section_container my-4 px-2 px-md-5 py-5">
      <div class="title">
        <h4>PAYMENT SCHEDULE</h4>
      </div>
      <div class="payment_schedule_container mt-2">
        <table>
          <thead>
            <tr>
              <th scope="col">AMOUNT</th>
              <th scope="col">DUE DATE</th>
              <th scope="col">PAYMENT DATE</th>
              <th scope="col">PAYMENT ID</th>
              <th scope="col">STATUS</th>
            </tr>
          </thead>
          <tbody>
            ${pagescontent[index].content.invoice_payment.map((data, i) => `
              <tr>
                <td data-label="Amount"><span class="hover_item">$${data.amount}</span></td>
                <td data-label="DUE DATE" class="due_date hover_payment position-relative">
                  <span class="hover_item">${data.dueDate}</span>
                </td>
                <td data-label="PAYMENT DATE">-</td>
                <td data-label="PAYMENT ID">${data.code}</td>
                <td data-label="STATUS" class="text-end position-relative"></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    </section>
  `;


      }



      if (pagescontent[index].type == 'questionnaires') {
        tabContent.innerHTML = `
    ${pagescontent[index].content.map((tabques, ind) => `
    <div class="position-relative overflow-hidden">
        <div class="form_container tab-content textContract">
    
            ${tabques.type === 'shorttext' ? `
                <div class='col-md-12 d-flex center'>
                    <div class='col-md-12 left' >
                        <label for='name' class='form-label mt-0'>${tabques.ques}</label>
                        <input type='text' class='form-control' id='name' name='name' placeholder="${tabques.placeholder}" />
                    </div>
                </div>
            ` : ''}
    
            ${tabques.type === 'FullwidthText' ? `
                <div class='col-md-12 left' >
                    
                    <div class='col-md-12'>
                        <label for='name' class='form-label mt-0'>${tabques.placeholder}</label>
                    </div>
                   
                </div>
            ` : ''}
    
            ${tabques.type === '2ColumnText' ? `
                <div class='col-md-12 d-flex left' >
                    <div class='col-md-6 margin'>
                        <label for='name' class='form-label mt-0'>${tabques.placeholder}</label>
                    </div>
                    <div class='col-md-6 margin'>
                        <label for='name' class='form-label mt-0'>${tabques.placeholder}</label>
                    </div>
                </div>
            ` : ''}
    
            ${tabques.type === 'twofields' ? `
                <div class='col-md-12 d-flex left'>
                    <div class='col-md-6 margin left'>
                        <label for='name' class='form-label mt-0'>${tabques.ques}</label>
                        <input type='text' class='form-control' id='name' name='name' placeholder="${tabques.placeholder}" />
                    </div>
                    <div class='col-md-6 margin left'>
                        <label for='name' class='form-label mt-0'>${tabques.ques2}</label>
                        <input type='text' class='form-control' id='name' name='name' placeholder="${tabques.placeholder2}" />
                    </div>
                </div>
            ` : ''}
    
            ${tabques.type === 'longtext' ? `
                <div class='col-md-12 d-flex left' >
                    <div class='col-md-12 left'>
                        <label for='name' class='form-label mt-0'>${tabques.ques}</label>
                        <textarea placeholder="${tabques.placeholder}" rows="1" cols="50" class="textare1">${tabques.placeholder}</textarea>
                    </div>
                </div>
            ` : ''}
    
            ${tabques.type === 'Dropdown' ? `
                
                    <div class='col-md-12 left' >
                        <div class='col-md-12 left'>
                            <label for='name' class='form-label mt-0'>${tabques.ques}</label><br/>
                            <label for='name' class='form-label mt-0'>${tabques.placeholder}</label>
                            
                        </div>
                    </div>
              
            ` : ''}
    
            ${tabques.type === 'Singlechoice' ? `
                <div class='col-md-12 mb-10 left' >
                    <label for='name' class='form-label mt-0'>${tabques.ques}</label>
                    ${tabques.option.map((optiontab, index2) => `
                        <div class='col-md-12 gapbetween' key=${index2}>
                            <div class='col-md-10'>
                            ${tabques.placeholder === optiontab.listpotion ? `<input type="radio" id="${optiontab.listpotion}" checked="true" name="fav_language" value="${optiontab.listpotion}" />
                                <label for="${optiontab.listpotion}">${optiontab.listpotion}</label><br/>` : `<input type="radio" id="${optiontab.listpotion}"  name="fav_language" value="${optiontab.listpotion}" />
                                <label for="${optiontab.listpotion}">${optiontab.listpotion}</label><br/>`}
                                
                            </div>
                        </div>
                    `).join('')}
                </div>
            ` : ''}
    
            ${tabques.type === 'Multichoice' ? `
                <div class='col-md-12 mb-10 left'>
                    <label for='name' class='form-label mt-0'>${tabques.ques}</label>
                    ${tabques.option.map((optiontab, index2) => `
                        <div class='col-md-12' key=${index2}>
                        ${tabques.placeholder2?.includes(optiontab.listpotion) ? `<input type="checkbox" id=${index2} checked="true" name="fav_language" value="${optiontab.listpotion}" checked="true" />
                            <label for=${index2}>${optiontab.listpotion}</label><br/>` : `<input type="checkbox" id=${index2}  name="fav_language" value="${optiontab.listpotion}"  />
                            <label for=${index2}>${optiontab.listpotion}</label><br/>`}
                            
                        </div>
                    `).join('')}
                </div>
            ` : ''}
    
            ${tabques?.type === 'DatePicker' ? `
                <div class='col-md-12 d-flex left' >
                    <div class='col-md-12'>
                        <label for='name' class='form-label mt-0'>${tabques.ques}</label>
                        <input type="date" class="datetype" value="${tabques.placeholder}" />
                    </div>
                </div>
            ` : ''}
        </div>
    </div>
    `).join('')}
`;


      }



      // Check if it's the last tab to include the signature
      if (index - pagescontent.findIndex(page => page.type === 'contract') === pagescontent.filter(page => page.type === 'contract').length - 1) {
        tabContent.innerHTML += `
  <p>
     <div className="signaturemain left w-100" style="font-family: 'Allura', cursive; font-size: 40px;width: 250px; height: 70px;"> 
         ${usersignature}
    </div>
  </p>
  <p> 
      <div className="sign_text">${username}  </div>
      <div className="sign_text">${useremail}</div>
  
  </p>
    <p>
      <div class="signaturemain left w-100" style="font-family: 'Allura', cursive; font-size: 40px;width: 250px; height: 70px;"> 
        ${customersignature}
      </div>
    </p>
    <p>
      <div className="sign_text">${customername} </div>
      <div className="sign_text">${customeremail}</div>
    
    
    </p>
  `;
      }



      pdfContent.appendChild(tabContent);

      // Add a page break after each tab's content except the last one
      if (index > 0) {
        const pageBreak = document.createElement('div');
        pageBreak.style.pageBreakAfter = 'always'; // Create a page break
        pdfContent.appendChild(pageBreak);
      }

    });

    // Create the PDF from the constructed content
    await html2pdf()
      .from(pdfContent)
      .set(options)
      .save(); // Saves the PDF locally


  }



  // setContractCount(count);
  if (!loading && !alreadysigned) {
    return <div>Loading...</div>;
  }


  if (alreadysigned) {
    return <div>You have already signed this contract</div>;
  }


  return (
    <>
      <div className="customer-view-translate-bar bg-light border-bottom">
        <div className="customer-view-translate-bar-inner">
          <TranslateWidget />
        </div>
      </div>
      <div className='container-fluid ' style={{ display: 'block ruby', textAlign: 'center' }}>
        <div className='row g-lg-5 g-md-5 g-3 px-lg-5' style={{ textAlign: 'center', margin: '0 auto', display: 'contents' }}>



          {/* Add Page part */}
          <div className='col-lg-8 widthfix-container'>
            <div
              className='text-editor px-2--px-md-5 py-3'
              style={{ background: "none", border: "none", height: "100%" }}>

              {!showpaging && (<>

                <div className="pagination-controls col-md-12 text-end pb-3">
                  <div style={{ position: "relative", display: "inline-block" }}>
                    {currentPage > 0 ? (<>
                      <button onClick={handlePreviousPage} disabled={currentPage === 0} className="Nxt">
                        Previous
                      </button>
                    </>) : (<></>)}

                    <span> Page {currentPage + 1} of {length + 2} </span>

                    {currentPage < length + 1 ? (<>

                      <button onClick={handleNextPage} disabled={currentPage - pagescontent.findIndex(page => page.type === 'contract') === pagescontent.filter(page => page.type === 'contract').length - 1 && customersignature == '' && contractpresent == true} className="Nxt"
                        onMouseOver={() => {


                          if (currentPage - pagescontent.findIndex(page => page.type === 'contract') === pagescontent.filter(page => page.type === 'contract').length - 1 && customersignature == '' && contractpresent == true) {
                            handleMouseOver();
                          }
                        }}
                        onMouseOut={handleMouseOut}
                      >
                        Next
                      </button>
                      {showTooltip && (
                        <div className="tooltip" style={{
                          position: "relative",
                          top: "10px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "#333",
                          color: "#fff",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          fontSize: "14px",
                          opacity: "1",
                          width: "350px",
                        }}>
                          To continue,first you need to sign the contract
                        </div>
                      )}


                    </>) : (<></>)}


                  </div>

                </div>

              </>)}






              {currentPage <= length && (<>



                {pagescontent.length && (<>

                  {pagescontent[currentPage].type == 'contract' && (<>

                    <div className=' px-2 px-md-5 py-3 ' style={{
                      backgroundColor: '#ffffff', border: '1px solid rgb(208, 200, 200)', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '20px',
                      margin: '0 auto'
                    }}>




                      {currentPage - pagescontent.findIndex(page => page.type === 'contract') == '0' && (<>
                        <TextEditorToSection userDetail={shareduserdetail} />
                      </>)}

                      <div className="row left">
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pagescontent[currentPage].content) }} />


                      </div>


                      {showsign && (<>

                        <div className={"tab-pane"} id='sign' role="tabpanel" aria-labelledby={`sign-tab`} style={{ background: 'white', height: '100%' }} >

                          <div className="position-relative overflow-hidden">

                            <div className="signat">

                              <div className="gap"> &nbsp; </div>
                              <div className="gap"> &nbsp; </div>
                              <div className="gap"> &nbsp; </div>




                              {usersignature !== null && (<>
                                <div className="signaturemain left w-100">
                                  {usersignature}
                                </div>
                              </>)}



                              <div className="sign_text">{username}  </div>
                              <div className="sign_text">{useremail}</div>

                              <div className="gap"> <hr /> </div>

                              {customersignature == "" && (<>
                                <div className="addbutton">
                                  <button

                                    className={`nav-link add_Signature`}
                                    type='button'
                                    data-bs-toggle='offcanvas'
                                    data-bs-target='#signpopup'
                                    aria-controls='offcanvasRight'
                                  >Add Signature </button>

                                </div>
                              </>)}

                              {customersignature != "" && (<>
                                <div className="signaturemain left w-100">
                                  {customersignature}
                                </div>
                              </>)}

                              <div className="sign_text">{customername} </div>
                              <div className="sign_text">{customeremail}</div>


                            </div>

                          </div>

                        </div>
                      </>)}






                    </div>


                  </>)
                  }








                  {pagescontent[currentPage].type == 'questionnaires' && (<>

                    <div className="position-relative overflow-hidden">
                      <div className="form_container tab-content textContract">


                        {pagescontent[currentPage].content.map((tabques, ind) => (<>



                          {/* start of   questionnaires */}


                          {tabques.type == 'shorttext' && (
                            <div className='col-md-12 d-flex center' key={ind}>

                              <div className='col-md-12 left' style={{ padding: '15px 20px' }}>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>
                                <input
                                  type='text'
                                  className='form-control'
                                  id='name'
                                  name='name'
                                  placeholder={tabques.placeholder}
                                  onChange={(e) => handlePlaceholderChange(e, currentPage, ind)}

                                />
                              </div>
                            </div>

                          )}


                          {tabques.type == 'FullwidthText' && (
                            <div className='col-md-12 left ' style={{ padding: '15px 20px' }}>
                              <div className='col-md-12 center'>&nbsp;</div>
                              <div className='col-md-12 '>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>

                              </div>
                              <div className='col-md-12 center'>&nbsp;</div>
                            </div>

                          )}


                          {tabques.type == '2ColumnText' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-6 margin '>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>
                              </div>
                              <div className='col-md-6 margin'>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>




                              </div>
                            </div>

                          )}


                          {tabques.type == 'twofields' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-6 margin left '>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>

                                <input
                                  type='text'
                                  className='form-control'
                                  id='name'
                                  name='name'
                                  placeholder={tabques.placeholder}
                                  onChange={(e) => handlePlaceholderChange(e, currentPage, ind)}
                                />
                              </div>
                              <div className='col-md-6 margin left'>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques2}
                                </label>


                                <input
                                  type='text'
                                  className='form-control'
                                  id='name'
                                  name='name'
                                  placeholder={tabques.placeholder2}
                                  onChange={(e) => handlePlaceholderChange2(e, currentPage, ind)}
                                />

                              </div>
                            </div>

                          )}

                          {tabques.type == 'longtext' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-12 left'>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>
                                <textarea placeholder={tabques.placeholder} rows={1} cols="50" name='' id='' className="textare1" onChange={(e) => handlePlaceholderChange(e, currentPage, ind)} />

                              </div>

                            </div>

                          )}


                          {tabques.type == 'Dropdown' && (
                            <> {tabques.optionadd == 0 ? (<div className='col-md-12 left' style={{ padding: '15px 20px' }}> <div className='col-md-12 left'>

                              <label htmlFor='name' className='form-label mt-0'>
                                {tabques.ques}
                              </label>

                              <select className="selectfull" onChange={(e) => handlePlaceholderChange(e, currentPage, ind)}>
                                {tabques.option.map((optiontab, index2) => (
                                  <option key={index2}>{optiontab.listpotion} </option>
                                ))}
                              </select>

                            </div></div>) : ('')}
                            </>

                          )}


                          {tabques.type == 'Singlechoice' && (
                            <><div className='col-md-12 mb-10 left' style={{ padding: '15px 20px' }} >

                              <label htmlFor='name' className='form-label mt-0'>
                                {tabques.ques}
                              </label>
                              {tabques.option.map((optiontab, index2) => (
                                <div className='col-md-12 gapbetween' key={index2}>
                                  <div className='col-md-10'>
                                    <input type="radio" id={optiontab.listpotion} onChange={(e) => handlePlaceholderChange(e, currentPage, ind)} name="fav_language" defaultValue={optiontab.listpotion} />
                                    <label htmlFor={optiontab.listpotion} >{optiontab.listpotion} </label><br />


                                  </div>

                                </div>
                              ))}

                            </div>
                            </>
                          )}


                          {tabques.type == 'Multichoice' && (
                            <> <div className='col-md-12 mb-10 left' style={{ padding: '15px 20px' }} >

                              <label htmlFor='name' className='form-label mt-0'>
                                {tabques.ques}
                              </label>
                              {tabques.option.map((optiontab, index2) => (
                                <div className='col-md-12' key={index2} >

                                  <input type="checkbox" id={index2} name="fav_language" defaultValue={optiontab.listpotion} onChange={(e) => handlePlaceholderChange3(e, ind)} />
                                  <label htmlFor={index2} >{optiontab.listpotion} </label><br />



                                </div>
                              ))}


                            </div>
                            </>
                          )}

                          {tabques?.type == 'DatePicker' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-12'>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>
                                <input type="date" className="datetype" onChange={(e) => handlePlaceholderChange(e, currentPage, ind)} />
                              </div>
                            </div>

                          )}



                          {/* end of   questionnaires */}





                        </>))}

                      </div>
                    </div>

                  </>)}












                  {/* invoice part start  */}


                  {pagescontent[currentPage].type == 'invoice' && (<>

                    {/* invoice section main part start */}



                    <section className='section_container'>
                      {/* Customer Details here */}
                      <div className='customer_details' style={{ textAlign: "left" }}>
                        {/* Customer info */}
                        {companylogo ? (
                          <>
                            <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div>
                          </>
                        ) : (<>

                        </>)}
                        <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div>
                      </div>

                      {/* Invoice content */}
                      <div className='invoice' style={{ textAlign: "left" }}>
                        <h3 style={{ margin: "0px 40px" }}>Invoice</h3>

                        {/* invoice table */}
                        <div className='invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4'>
                          <div
                            className='table_item  invoice_td position-relative'
                            type='button' style={{ textAlign: 'left', paddingLeft: "50px" }}>
                            <span className="hover_effect">Bill to</span><br />

                            <span >{customername}</span>


                          </div>
                          <div
                            className='table_item  invoice_td position-relative'
                            type='button' style={{ marginRight: '6%', textAlign: 'left' }}>
                            <span className="hover_effect">invoice #</span><br />
                            <span>{invoicecode}</span>


                          </div>

                          <div className='table_item  purchase_td position-relative' style={{ marginRight: '1%', textAlign: 'left' }}>
                            <span className="hover_effect">Purchase order #</span><br />
                            <span>{purchageorder}</span>

                          </div>
                        </div>

                        <div className='invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4'>
                          <div></div>
                          <div className='table_item table_item_date_issued position-relative'>
                            <span>&nbsp;Date Issued</span> <br />
                            <div
                              className='date position-absolute'
                              style={{ fontSize: "14px" }}>
                              &nbsp;{formattedDate}
                            </div>
                          </div>
                          <div className='table_item position-relative'>
                            <span>Next Payment Due</span>
                            <br />
                            <div
                              className='date position-absolute'
                              style={{ fontSize: "14px" }}>
                              {pagescontent[currentPage].content.invoice_payment[0].dueDate}
                            </div>
                          </div>
                        </div>

                        {/* service area */}
                        <div className='service_area d-flex align-items-center justify-content-between py-3'>
                          <div className='service_item'>
                            <div className='service_info_top'>
                              <span>SERVICE INFO</span>
                            </div>
                          </div>
                          <div className='service_item d-flex align-items-center'>
                            <span className='me-5'>QTY</span>
                            <span>UNIT</span>
                          </div>
                          <div className='service_item'>
                            <span className='me-3'> { /*TAX*/}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; </span>
                            <span>PRICE</span>
                          </div>
                        </div>

                        {/* create new service */}
                        {/* Render dynamic services */}


                        {pagescontent[currentPage].content.invoice_item.map((service, index) => (
                          <div
                            key={index}
                            className='create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative'>
                            <div className='service_item position-relative'>
                              <div className='service_info_box' style={{ marginTop: "41px" }}>
                                <div
                                  className='service_info'>

                                  <input type='text' id={`name-${index}`} placeholder='Type or Select a Service' value={service.type} disabled style={{ background: 'none' }} />
                                  <small></small>
                                </div>
                                <div className='desc mt-2'> &nbsp;
                                  {/* <textarea name="" className="textare" placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)}></textarea> */}
                                  {/* <input type='text' placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)} /> */}
                                </div>
                              </div>


                              {/* Select item */}

                            </div>
                            <div className='service_item d-flex align-items-center'>
                              {/* QYT field */}
                              <span className='me-2 qyt'>
                                {service.qty}

                              </span>

                              {/* UNIT Field */}
                              <span className='position-relative'>

                                <UnitOption indexval={index} rawselectedOption={service.unit_option} />
                              </span>
                            </div>
                            <div className='service_item d-flex align-items-center'>
                              <div className='form-check '>
                                { /* <input
                              className='form-check-input'
                              type='checkbox'
                              name='tax'
                              value=''
                              id='flexCheckDefault'
                              checked={service.tax ? 'checked' : ''}
                            /> */}
                              </div>
                              <div className='form-check qyt'>
                                {service.price}

                                <small></small>

                              </div>
                            </div>

                            {/* Delete button */}


                            <div className="textare2 left">


                              <textarea ref={el => ref2.current[index] = el} placeholder='Enter a description' rows={1} onInput={(e) => handleInput(e, index)} name={index} id={`desc-${index}`} className="textare" value={service.descp}
                                disabled style={{ borderBottom: 'none !important' }} />
                              <small></small>
                            </div>

                          </div>
                        ))}

                        {/* add new item button  */}


                        {/* Summary*/}
                        <div className='card-body'>
                          <div className='row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0'>
                            <div className='col-md-5 d-flex align-items-end'></div>

                            <div className='col-md-7 ml-auto'>
                              <table className='table create_invoice_table table-clear'>
                                <tbody>
                                  <tr>
                                    <td className='left'>
                                      <span>Subtotal</span>
                                    </td>
                                    <td className='right'>${subtotalprice}</td>
                                  </tr>
                                  {/* Tax box */}
                                  <tr>
                                    <td className='left position-relative'>
                                      <span className='pointer' >
                                        Tax {/* <span>8.5%</span> */}
                                      </span>
                                      {showTaxBox && (
                                        <div className='edit_discount_box edit_tax_box position-relative'>
                                          <div className='box_header d-flex align-items-center justify-content-between mb-2'>
                                            <h5>Edit Tax</h5>
                                            <span >
                                              <i className='fas fa-close'></i>
                                            </span>
                                          </div>
                                          <div className='box-content mt-2 d-flex align-items-center'>
                                            <input
                                              type='number'
                                              className='me-2'
                                              placeholder='Tax'
                                              defaultValue=''

                                            />


                                            <div className='input-group'>
                                              <span className={`input-group-text `}

                                                id='basic-addon1' >
                                                %
                                              </span>
                                              <span className={`input-group-text `}

                                                id='basic-addon1' >
                                                $
                                              </span>
                                            </div>

                                            {/* delete button */}
                                            <div>
                                              {" "}
                                              <i className='fas fa-trash text-danger' ></i>
                                            </div>
                                          </div>

                                          <div className='discount_arrow'></div>
                                        </div>
                                      )}
                                    </td>
                                    <td className='right'>${taxval}</td>
                                  </tr>

                                  {/* add discount box */}
                                  <tr>
                                    <td className='left position-relative'>
                                      {showDiscountBox ? (
                                        <span className='pointer'>Discount</span>
                                      ) : (
                                        <span className='pointer' >
                                          + Add Discount
                                        </span>
                                      )}

                                      {/* edit discount box */}
                                      {showDiscountBox && (
                                        <div className='edit_discount_box position-relative'>
                                          <div className='box_header d-flex align-items-center justify-content-between mb-2'>
                                            <h5>Edit Discount</h5>
                                            <span >
                                              <i className='fas fa-close'></i>
                                            </span>
                                          </div>
                                          <div className='box-content mt-2 d-flex align-items-center'>
                                            <input type='number' className='me-2' defaultValue='' />

                                            <div className='input-group'>
                                              <span className={`input-group-text `}

                                                id='basic-addon1'  >
                                                %
                                              </span>
                                              <span className={`input-group-text `}
                                                id='basic-addon1' >
                                                $
                                              </span>
                                            </div>

                                            {/* delete button */}
                                            <div>
                                              {" "}
                                              <i className='fas fa-trash text-danger'  ></i>
                                            </div>
                                          </div>

                                          <div className='discount_arrow'></div>
                                        </div>
                                      )}
                                    </td>
                                    <td className='right'>
                                      <strong>${discountval}</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className='left'>
                                      <span>Total USD</span>
                                    </td>
                                    <td className='right'>
                                      <strong> {totalprice} </strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* PAYMENT SCHEDULE */}
                    <section className='section_container my-4 px-2 px-md-5 py-5'>
                      <div className='title'>
                        <h4>PAYMENT SCHEDULE</h4>
                      </div>

                      <div className='payment_schedule_container mt-2'>
                        <table>
                          <thead>
                            <tr>
                              <th scope='col' style={{ width: "74px" }}>
                                AMOUNT
                              </th>
                              <th scope='col'>DUE DATE</th>
                              <th scope='col'>PAYMENT DATE</th>
                              <th scope='col'>PAYMENT ID</th>
                              <th scope='col' style={{ width: "74px" }}>
                                STATUS
                              </th>
                            </tr>
                          </thead>
                          <tbody>

                            {pagescontent[currentPage].content.invoice_payment.map((data, i) => (
                              <tr key={i}>
                                <td data-label='Amount'>
                                  <span className='hover_item'>

                                    ${data.amount}</span>
                                </td>
                                <td
                                  data-label='DUE DATE'
                                  className='due_date hover_payment position-relative'>
                                  <span
                                    className='hover_item'
                                  >
                                    {data.dueDate}

                                    {showDueDateBox === i && (
                                      <div
                                        className='due_date_box'
                                      >
                                        <div className='due_date_box_header d-flex align-items-center justify-content-between'>
                                          <h4>Set Payment Due</h4>
                                          <span >
                                            <i className='fas fa-close'></i>
                                          </span>
                                        </div>
                                        <div className='arrow'></div>

                                        <div className='due_date_box_content mt-2'>
                                          {smartdate && (
                                            <CommonDropdownMenuThree options={options} suboption={options_sub} rawselectedOption={options[1]} />
                                          )
                                          }

                                          {!smartdate && (
                                            <CommonDropdownMenuThree options={options} suboption={options_sub} rawselectedOption={options[0]} />
                                          )
                                          }

                                          {
                                            smartdate && (
                                              <div className="d-flex smartdate">
                                                <input className="smardatinp" value={smartday} onChange={(e) => setsmartday(e.target.value)} />&nbsp;
                                                <CommonDropdownMenufour options={options2} />&nbsp;
                                                <CommonDropdownMenufour options={options3} />
                                              </div>
                                            )

                                          }


                                          {!smartdate && (
                                            <div className='mt-3 date_input'>
                                              <input
                                                type='date'


                                              />
                                            </div>
                                          )

                                          }



                                          <div className='mt-3 text-end'>
                                            <button >
                                              Save
                                            </button>
                                          </div>
                                        </div>

                                        <div className='arrow'></div>
                                      </div>
                                    )}
                                  </span>
                                </td>
                                <td data-label='PAYMENT DATE'>{data.paid_at === "-"
                        ? data.paid_at
                        : new Date(data.paid_at).toLocaleDateString("en-US", {
                            timeZone: "UTC",
                          })}</td>
                                <td data-label='PAYMENT ID'>{invoicecode}</td>
                                <td
                                  data-label='STATUS'
                                  className='text-end position-relative'
                                  style={{ cursor: "pointer" }}>
                                  {data.status}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {/* add new payment button  */}

                    </section>

                    {/* invoice section main part end */}

                  </>)
                  }

                  {pagescontent[currentPage].type == 'payment' && (<>
                    <div style={{ textAlign: 'left' }}>
                      <CreatePayContent paidpayment1={invoicepayments} sharedproposalinvoice={sharedproposalinvoice} />
                    </div>
                  </>)}


                </>)

                }

              </>)}


              {usersignature != '' && currentPage == length + 1 && (<>

                <div className=' px-2 px-md-5 py-3 ' style={{
                  backgroundColor: '#ffffff', border: '1px solid rgb(208, 200, 200)', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '20px',
                  margin: '0 auto'
                }}>

                  <div style={{ width: '75%', margin: '0px auto', paddingTop: '50px', paddingBottom: '50px' }}>

                    <div className='logo' style={{ width: '50%', margin: '0px auto' }}>
                      <h4>
                        <img src={shareduserdetail.Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + shareduserdetail.Secondary_Logo : null} alt='Secondary Logo Preview' className='mainimgpath img-fluid' style={{ maxWidth: '200px' }} />
                      </h4>
                    </div>

                    <div style={{ fontSize: '26px' }}><b>All done!</b></div>

                    <div style={{ textAlign: "centre", margin: '10px' }}>Thank you for reviewing the proposal. You can download a copy from the link below, and a copy will also be sent to your email for your records. If you have any questions or need further details, please feel free to reach out. </div>
                    <div> <span onClick={generatepdf2} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Click Here to Download Proposal</span> </div>
                  </div>

                </div>

              </>)}














              <div className='tab-content h-100' id='v-pills-tabContent'>{showsign}




                {/* add page */}









                {proposalstabs.length == 0 && proposalpages.length == 0 && (

                  <div
                    onClick={handleAddPage}
                    className='add-page add-proposal  d-flex flex-column justify-content-center align-items-center text-center h-100'
                    type='button'
                    data-bs-toggle='offcanvas'
                    data-bs-target='#offcanvasRight'
                    aria-controls='offcanvasRight'>
                    <img src='/img/edit_icon.png' alt='ICON' />
                    <h2 className='mt-4'>Add page</h2>
                  </div>


                )}


              </div>
            </div>

            {/* Paging Area start */}
            {!showpaging && (<>

              <div className="pagination-controls col-md-12 text-end pb-3">
                <div style={{ position: "relative", display: "inline-block" }}>
                  {currentPage > 0 ? (<>
                    <button onClick={handlePreviousPage} disabled={currentPage === 0} className="Nxt">
                      Previous
                    </button>
                  </>) : (<></>)}

                  <span> Page {currentPage + 1} of {length + 2} </span>

                  {currentPage < length + 1 ? (<>
                    {showTooltip && (
                      <div className="tooltip2" style={{
                        top: "-40px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#333",
                        color: "#fff",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        opacity: "1",
                        width: "350px",
                      }}>
                        To continue,first you need to sign the contract
                      </div>
                    )}

                    <button onClick={handleNextPage} disabled={currentPage - pagescontent.findIndex(page => page.type === 'contract') === pagescontent.filter(page => page.type === 'contract').length - 1 && showsign} className="Nxt"
                      onMouseOver={() => {


                        if (currentPage - pagescontent.findIndex(page => page.type === 'contract') === pagescontent.filter(page => page.type === 'contract').length - 1 && customersignature == '' && contractpresent == true) {
                          handleMouseOver();
                        }
                      }}

                    >
                      Next
                    </button>



                  </>) : (<></>)}


                </div>

              </div>

            </>)}

            {/* Paging Area end*/}



          </div>
        </div>
      </div>

      {/* start of the sign popup */}
      <div
        class='offcanvas offcanvas-end'
        tabindex='-1'
        id='signpopup'
        aria-labelledby='offcanvasRightLabel'
        data-bs-backdrop='false'>
        <div class='w-100 text-start header'>
          <button
            type='button'
            class='btn-close mt-3 ms-4 text-black'
            data-bs-dismiss='offcanvas'
            aria-label='Close'></button>


          <div className='text-center py-3'>
            <h5>Signature</h5>
            <span style={{ color: "#727272" }}>
              Add Your Signature
            </span>
          </div>
        </div>


        <div class='offcanvas-body p-0'>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="text" className="signbox" onChange={handleChange} value={signaturebox} />
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="checkbox" onChange={handleCheckboxChange} />By Clicking, I, <b> {customername}  </b> hereby consent to the use of my electronic signature for the execution of this document. I acknowledge and agree that my electronic signature shall have the same validity, enforceability, and legal effect as my handwritten signature.
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <button
                  type='button'
                  class='mt-3 ms-4 text-black backbackground add_Signature'
                  data-bs-dismiss='offcanvas'
                  disabled={!isChecked}
                  onClick={addsignature}
                  aria-label='Close'>SIGN</button>
              </div>
            </div>
          </div>

        </div>

      </div>



      {/* end of the sign popup */}


    </>
  );
})